import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="bg-navy-950 py-14 sm:py-20" data-id="element-140" data-mp="3mujt7fpda4qk">
      <div className="mx-auto w-full max-w-2xl px-4 text-center" data-id="element-141" data-mp="3mrxodntv23c1">
        <span className="inline-block rounded-full bg-white/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-sky-400 sm:text-xs" data-id="element-142" data-mp="3rraau7gtl8e3">
          🦷 Ready to stop starting with the appliance?
        </span>
        <h2 className="mt-5 font-display text-[30px] font-bold leading-tight text-white sm:text-5xl" data-id="element-143" data-mp="3hsce4h98q8k0">
          Start with the objective.
        </h2>
        <p className="mx-auto mt-4 max-w-md text-[16px] leading-relaxed text-white/75 sm:text-lg" data-id="element-144" data-mp="38v23my48yng5">
          Structure your biomechanical reasoning with a visual decision system.
        </p>

        <div className="mt-8" data-id="element-145" data-mp="172w3a48rtch9">
          <CTAButton size="large" label="Yes — I want Mechanics Decision Map™" subline="Only $27 · Instant digital access · Lifetime access · 7-day guarantee" data-id="element-146" data-mp="17247otf6beqz" />
        </div>

        <p className="mx-auto mt-5 flex max-w-md items-center justify-center gap-2 rounded-xl bg-white/[0.06] px-4 py-3 text-center text-[12.5px] font-medium leading-snug text-white/75 ring-1 ring-white/10 sm:text-sm" data-id="element-147" data-mp="l7psejer4u1p">
          <GlobeIcon className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" data-id="element-148" data-mp="79hofrjassh1" />
          Currency conversion is automatic based on your location.
        </p>

        <div className="mt-5" data-id="element-149" data-mp="2citj6rt8hhs">
          <ScarcityBar tone="dark" data-id="element-150" data-mp="gafra6i02ty1" />
        </div>

        <div className="mt-8" data-id="element-151" data-mp="gc0pc63iwv0n">
          <Countdown tone="dark" data-id="element-152" data-mp="g833vdth3rdl" />
        </div>
      </div>
    </section>;
}